import { createTheme, type MantineColorsTuple } from '@mantine/core';

// 10-shade palette anchored at shade 6 = #d6f5ee (--rl-primary).
// Shade 7 is a subtle dim of shade 6 — just enough for hover
// feedback without shifting to a different color.
const rlPrimary: MantineColorsTuple = [
  '#f0fdf9',
  '#e4fbf4',
  '#d6f5ee',
  '#b0e8d9',
  '#8adbc5',
  '#64ceb1',
  '#d6f5ee', // shade 6 — the canonical --rl-primary
  '#b3ddd3', // shade 7 — hover, slightly dimmed
  '#2d7a63',
  '#1f5646',
];

// 10-shade palette anchored at shade 6 = #d45050 (--rl-danger).
// Shade 7 is a subtle dim of shade 6 for hover.
const rlDanger: MantineColorsTuple = [
  '#fef2f2',
  '#fde8e8',
  '#f9bfbf',
  '#f49696',
  '#ee6d6d',
  '#e05555',
  '#d45050', // shade 6 — the canonical --rl-danger
  '#b54242', // shade 7 — hover, slightly dimmed
  '#922e2e',
  '#712222',
];

export const theme = createTheme({
  primaryColor: 'rlPrimary',
  primaryShade: { dark: 6, light: 6 },
  autoContrast: true,
  colors: {
    rlPrimary,
    rlDanger,
  },
  fontFamily: "'IBM Plex Sans', sans-serif",
  headings: {
    fontFamily: "'IBM Plex Sans', sans-serif",
    fontWeight: '600',
  },
  defaultRadius: 'md',
  components: {
    Button: {
      defaultProps: {
        color: 'rlPrimary',
      },
    },
  },
});
